"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimelineItemId = getTimelineItemId;

var _immutable = require("immutable");

var _getIn = _interopRequireDefault(require("transmute/getIn"));

function getTimelineItemId(timelineItem) {
  if (!_immutable.Map.isMap(timelineItem)) {
    return null;
  }

  var id = (0, _getIn.default)(['engagement', 'id'], timelineItem) || (0, _getIn.default)(['eventData', 'engagement', 'id'], timelineItem) || (0, _getIn.default)(['eventData', 'id'], timelineItem) || timelineItem.get('id');
  return "" + id;
}